import { useQuery } from "@tanstack/react-query";
import { QuotationRequestInterface } from "../../../../models/ProcurementModule/QuotationRequest";
import { CACHE_KEY_QUOTATIONREQUESTS } from "../../../../utils/constants";
import quotationRequestService from "../../../../services/procurementService/quotationRequestService";

const useQuotationRequestById = (id: string | undefined | null) =>
  useQuery<QuotationRequestInterface, Error>({
    queryKey: [`${CACHE_KEY_QUOTATIONREQUESTS}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, quotationRequestId] = queryKey;

      // Guard clause to ensure query doesn't execute if id is invalid
      if (!quotationRequestId || typeof quotationRequestId !== "string") {
        return Promise.reject(new Error("Invalid ID provided"));
      }

      return quotationRequestService.GetById(quotationRequestId);
    },
    enabled: !!id && id.trim() !== "", // Ensures `id` is not undefined, null, or an empty string
  });

export default useQuotationRequestById;
